import React from 'react';
import { Neo } from '@singularsystems/neo-react';
import { ReportingView } from '@singularsystems/neo-reporting';
import { IReportType } from '@singularsystems/neo-reporting/dist/Models/IReportType';
import { ClientReportCategories } from './ClientReportCategories';
import { RegulatoryReports } from '../Models/Security/Roles';
import { Misc } from '@singularsystems/neo-core';
import { Types } from '../Services/NeoReportingTypes';

export default class ClientReportsView extends ReportingView {
    public authorisationService = Misc.Globals.appService.get(Types.Neo.Security.AuthorisationService)

    protected renderReportListSection() {
        var clientReportsCategories = Object.values(ClientReportCategories).toString();
        const allReports = this.viewModel.reportingService.reports.groupBy(c => c.reportInfo.category, (c, i, d) => ({ category: c, reports: d }));

        let clientReports: {
            category: string,
            reports: IReportType[],
        }[] = [];

        allReports.forEach((report) => {
            if (clientReportsCategories.includes(report.category)) {
                if (report.category === ClientReportCategories.RegulatoryReports) {
                    // If the report is a regulatory report, check if the user has the appropriate role
                    if (this.authorisationService.hasRole(RegulatoryReports.View) || this.authorisationService.hasRole(RegulatoryReports.Download)) {
                        clientReports.push(report);
                    }
                }
                // Temporary workaround for client report loading network error. Tickets: STODAR-1255, 1256, 1257, 1258, 1259
                /* else {
                     clientReports.push(report);
                } */
            }
        });

        let categoryCards: JSX.Element[];
        if (this.mustArrangeReportCards) {
            categoryCards = this.arrangeReportCardColumns(clientReports);
        }
        else {
            categoryCards = this.renderReportList(clientReports);
        }

        return (<Neo.GridLayout xl={3}>
            {categoryCards}
        </Neo.GridLayout>)
    }
}